import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { STATUS_VALUE_OPTIONS } from '../optionValues';

export const PRIORITY_OPTIONS_ES = [
  { value: 'High', label: 'Alta' },
  { value: 'Medium', label: 'Media' },
  { value: 'Low', label: 'Baja' },
];

export const KEY_COMPETITORS_PRIORITY_OPTIONS_ES = [
  { value: 'High', label: 'Alta' },
  { value: 'Medium', label: 'Media' },
  { value: 'Low', label: 'Baja' },
];

export const TERMS_OPTIONS_ES = [
  { value: 'longTerm', label: 'Largo plazo' },
  { value: 'shortTerm', label: 'Corto plazo' },
];

export const LIFE_CYCLE_STAGES_OPTIONS_ES = [
  { label: 'Idea', value: 'Idea' },
  { label: 'I+D', value: 'R&D' },
  { label: 'Crecimiento', value: 'Growth' },
  { label: 'Madurez', value: 'Maturity' },
];

export const PROJECT_STATUS_OPTIONS_ES = [
  { value: 'Idea Assessment', label: 'Evaluación de la idea' },
  { value: 'Research and Development', label: 'Investigación y desarrollo' },
  { value: 'Evaluation and Selection', label: 'Evaluación y selección' },
  { value: 'Financing', label: 'Financiación' },
  { value: 'Implementation', label: 'Implementación' },
  { value: 'Operation and Management', label: 'Operación y gestión' },
];

export const FUNDING_DIRECTIONS_OPTIONS_ES = [
  { label: 'Investigación y Desarrollo (I+D)', value: 'Research and Development (R&D)' },
  { label: 'Marketing y ventas', value: 'Marketing and Sales' },
  { label: 'Capital de trabajo', value: 'Working Capital' },
  { label: 'Construcción de edificios e instalaciones', value: 'Construction of Buildings and Facilities' },
  { label: 'Compra de equipos', value: 'Purchase of Equipment' },
];

export const STATUS_OPTIONS_ES = [
  { value: STATUS_VALUE_OPTIONS.DONE, label: 'Completado' },
  { value: STATUS_VALUE_OPTIONS.IN_PROGRESS, label: 'En progreso' },
  { value: STATUS_VALUE_OPTIONS.TO_DO, label: 'Pendiente' },
];

export const GENDER_OPTIONS_ES = [
  { value: 'Male', label: 'Masculino' },
  { value: 'Female', label: 'Femenino' },
  { value: 'Gender-Neutral', label: 'Neutro' },
];

export const PRODUCT_SERVICE_OPTIONS_ES = [
  { value: 'Product/Service', label: 'Producto/Servicio' },
  { value: 'Region', label: 'Región' },
  { value: 'Market Segment', label: 'Segmento de mercado' },
];

export const CONSUMER_OPTIONS_ES = [
  { value: 'Product', label: 'Producto' },
  { value: 'Service', label: 'Servicio' },
  { value: 'Consumer', label: 'Consumidor' },
  { value: 'Producer', label: 'Productor' },
  { value: 'Other Market Segment', label: 'Otro segmento de mercado' },
];

export const UNITS_VALUES_ES = {
  VOLUME_IN: 'Volumen en',
  CURRENCY: 'Moneda',
} as const;

export const PREMISE_TERMS_OF_USE_OPTIONS_ES = [
  { value: 'Ownership', label: 'Propiedad' },
  { value: 'Renting', label: 'Alquiler' },
  { value: 'Leasing', label: 'Arrendamiento financiero' },
  { value: 'Shared Ownership', label: 'Propiedad compartida' },
];

export const DELIVERY_TERMS_OPTIONS_ES = [
  { value: 'Prepayment', label: 'Pago anticipado' },
  { value: 'Upon delivery', label: 'Contra entrega' },
  { value: 'Deferred payment', label: 'Pago diferido' },
];

export const RISKS_OPTIONS_ES = [
  { value: 'marketRisks', label: 'Riesgos de mercado' },
  { value: 'operationalRisks', label: 'Riesgos operativos' },
  { value: 'financialRisks', label: 'Riesgos financieros' },
  { value: 'legalAndRegulatoryRisks', label: 'Riesgos legales y regulatorios' },
  { value: 'technologicalRisks', label: 'Riesgos tecnológicos' },
  { value: 'humanResourceRisks', label: 'Riesgos de recursos humanos' },
  { value: 'environmentalRisks', label: 'Riesgos medioambientales' },
  { value: 'other', label: 'Otros' },
];

export const ONE_PAGE_OPTIONS_ES = [
  { label: 'Breve', value: BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT },
  { label: 'Completo', value: BUSINESS_PLAN_TYPES.ONE_PAGE },
];

